
namespace RedBullMOBILE360.Administration {
    export class DbLinkMapColumns {
        static columnsKey = 'Administration.DbLinkMap';
    }
}